const getters = {
  isLogin: state => state.global.login,
  full: state => state.global.full
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js